import { HRQuestionTemplateId } from "./messages/ObjectIds";

export class Globals {
    private static lastUsedSignature: string | null = null;
    private static lastSSN: string | null = null;
    private static lastBirthDate: string | null = null;
    private static answerMapByTemplateId = new Map();

    public static getAnswerByTemplateId(id: HRQuestionTemplateId) {
        const temp = this.answerMapByTemplateId.get(HRQuestionTemplateId.unwrap(id));
        if (temp === undefined) {
            return null;
        }

        return temp;
    }

    public static setAnswerByTemplateId(id: HRQuestionTemplateId, val: any) {
        return this.answerMapByTemplateId.set(HRQuestionTemplateId.unwrap(id), val);
    }

    public static getLastUsedSignature() {
        return this.lastUsedSignature;
    }

    public static setLastUsedSignature(val: string | null) {
        this.lastUsedSignature = val;
    }

    public static getLastSSN() {
        return this.lastSSN;
    }

    public static setLastSSN(newSSN: string | null) {
        return this.lastSSN = newSSN;
    }

    public static getLastBirthDate() {
        return this.lastBirthDate;
    }

    public static setLastBirthDate(newBirthDate: string | null) {
        return this.lastBirthDate = newBirthDate;
    }
}



// WEBPACK FOOTER //
// ./src/Globals.ts